
import { HttpErrorResponse } from '@angular/common/http';
import { CommonApi } from '@app/modules/core/api/common.api';

import { OAuthApi, RefreshTokenApi } from '@app/modules/core/api/oauth.api';
import { Observable, of, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { delay } from 'rxjs/operators';
export class AuthMockService {

     readonly mockDelay = 500;

    private userErrorMessageMap = new Map<string, CommonApi.MessageCode | string>();

    constructor() {

        this.userErrorMessageMap.set( 'invalid' , CommonApi.MessageCode.invalidPassword );
        this.userErrorMessageMap.set( 'locked' , CommonApi.MessageCode.accountLocked );
        this.userErrorMessageMap.set( 'exceed' , CommonApi.MessageCode.exceededNoOfAttempt );
        this.userErrorMessageMap.set( 'temp' , CommonApi.MessageCode.tempPassword );
    }

    refreshAccessToken(
        refreshToken: string
      ): Observable<RefreshTokenApi.Response> {
        return of( { access_token: 'a_token', scope: '', refresh_token: 'r_token', expires_in: -1, token_type: ''  } ).pipe( delay(  this.mockDelay ) );
    }

    logout( token: string ): Observable<void> {
        return of( undefined );
    }
    public login(userName: string, password: string): Observable<OAuthApi.Login.Response> {

        if ( this.userErrorMessageMap.get( userName ) ) {

            return throwError(
                new HttpErrorResponse({
                    status: 500,
                    statusText: 'Error Lik!',
                    error: {
                        messages: [ { type: 'ERROR', code: this.userErrorMessageMap.get( userName ) } ]
                    }
                })
            );

        }
        const response: OAuthApi.Login.Response = {
            access_token: 'access_token',
            token_type: 'token_type',
            expires_in: 234234234,
            refresh_token: 'refresh_token',
            scope: ''
        };
        return of( response ).pipe( delay(  this.mockDelay ) );

    }
}
